/**
 * Java called System.exit(0) from the pause-menu Quit and the main-menu X.
 *
 * A browser tab cannot terminate itself: window.close() is ignored unless the page was
 * opened by script. Left as-is, both buttons would silently do nothing. So we try to close,
 * and otherwise hand off to a host-supplied handler (main.ts) that halts the game and
 * returns to the boot screen — the closest honest equivalent of quitting.
 */

let handler: (() => void) | null = null;

export function setQuitHandler(fn: () => void): void {
  handler = fn;
}

export function quitGame(): void {
  window.close();
  // Still here, so the tab refused to close (the normal case).
  handler?.();
}
